import { render } from "./NavbarSection.vue?vue&type=template&id=6879a9d1&scoped=true"
import script from "./NavbarSection.vue?vue&type=script&lang=js"
export * from "./NavbarSection.vue?vue&type=script&lang=js"

import "./NavbarSection.vue?vue&type=style&index=0&id=6879a9d1&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\registration2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6879a9d1"]])

export default __exports__